import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The full-screen quad that writes `S`'s starting value, which the pass swaps per pass. A quad,
 * not a clear colour, so the seed skips colour management on its way into a `NoColorSpace` target
 * and the renderer's global clear state stays untouched.
 */
import * as THREE from 'three';
import { LIGHT_PASS_LAYER, SEED_RENDER_ORDER } from './lightPassLayers.js';
import { FULL_SCREEN_VERTEX } from '../fullScreenPass.js';
import { FullScreenQuad } from './fullScreenQuad.js';
const SEED_FRAGMENT = /* glsl */ `
uniform vec3 uSeed;
void main() {
  // rgb: where Godot's base pass leaves the item, with the albedo divided out.
  // alpha: no light has been counted yet.
  gl_FragColor = vec4(uSeed, 0.0);
}
`;
export function createSeedMaterial() {
    return new THREE.ShaderMaterial({
        vertexShader: FULL_SCREEN_VERTEX,
        fragmentShader: SEED_FRAGMENT,
        uniforms: { uSeed: { value: new THREE.Vector3(1, 1, 1) } },
        // NoBlending, so the quad overwrites: it is the clear. `transparent` puts it in the light
        // quads' sorted list, so `renderOrder` places it beneath them.
        blending: THREE.NoBlending,
        transparent: true,
        depthTest: false,
        depthWrite: false,
    });
}
/** Every pass draws the seed, so it stays visible on the light pass layer, which the main render skips. */
function toLightPassLayer(mesh) {
    mesh?.layers.set(LIGHT_PASS_LAYER);
}
/** Writes `S`'s starting value over the whole accumulator, under every light. */
export function LightAccumulatorSeed({ material }) {
    return _jsx(FullScreenQuad, { meshRef: toLightPassLayer, material: material, renderOrder: SEED_RENDER_ORDER });
}
//# sourceMappingURL=lightSeedQuad.js.map